module.exports = __webpack_public_path__ + "img/mollie-vector-logo-red.63b57672.png";